

import Vue from "vue";
import { Extension, Queue, Trunk, User } from "@/types/conf";
import { mapActions, mapGetters } from "vuex";
import * as action from "@/store/actions";

import Top from "@/components/templates/Top.vue";
import IpInfoPanel from "@/components/templates/IpInfoPanel.vue";
import i18n from "@/plugins/i18n";

export default Vue.extend({
  name: "Panel",
  data: () => ({
    clonedItemOptions: {
      group: "items",
    },

    actionList: [] as any[],
    currentPageExtens: 0,
    itemsPerPageExtens: 20,
    currentPage: 0,
    viewHeight: true,
    itemsPerPage: 10,
    filterStatus: "all" as string,
    search: "" as string,
    searchTerm: "" as string,
    queueListKey: 0,
    trunkList: [] as Trunk[],
    userList: [] as User[],
  }),
  components: {
    Top,
    IpInfoPanel
  },
  computed: {
    ...mapGetters({
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
      extenList: "panel/extenList",
      queueList: "panel/queueList",
      callTimes: "panel/callTimes",
      callerList: "panel/currentCallList",
    }),

    totalPages() {
      return Math.ceil(this.filteredCallerList.length / this.itemsPerPage);
    },
    paginatedCallerList() {
      const start = this.currentPage * this.itemsPerPage;
      return this.filteredCallerList.slice(start, start + this.itemsPerPage);
    },
    paginatedExtensions() {
      const start = this.currentPageExtens * this.itemsPerPageExtens;
      return this.filteredExtensions.slice(start, start + this.itemsPerPageExtens);
    },
    totalPagesExtens() {
      return Math.ceil(this.filteredExtensions.length / this.itemsPerPageExtens);
    },
    filteredExtensions() {
      return this.extenList
        .filter(exten => {
          if (this.filterStatus === 'online') return exten.status !== 0;
          if (this.filterStatus === 'offline') return exten.status === 0;
          return true;
        })
        .filter(exten => {
          const user = this.userList.find(user => user.id === exten.userId);
          const userName = user ? user.name.toLowerCase() : '';
          return exten.number.toString().includes(this.search) ||
                userName.includes(this.search.toLowerCase());
        });
    },
    filteredCallerList() {
      // Filtrar según el searchTerm y trunkList
      return this.callerList.filter(caller => {
        const isTrunkNumberValid = this.trunkList.some(trunk => trunk.number === caller.trunkNumber);
        return caller.caller.toLowerCase().includes(this.searchTerm.toLowerCase()) && isTrunkNumberValid;
      });
    },
    searchByNumber(): Extension[] {
      return this.extenList.filter((element: Extension) => {
        return element.number?.toString().includes(this.search) ||
          element.userName?.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    paginate(): any[] {

      if (this.currentPage >= this.totalPages) this.currentPage = 0;

      let index = this.currentPage * this.itemsPerPageExtens;

      return this.searchByNumber.slice(index, index + this.itemsPerPageExtens);
    },
  },
  methods: {
    ...mapActions({
      getActions: "crudService/getDetail",
      stopPanel: "panel/stopPanel",
      deleteItem: "panel/deleteQueueMember",
      addToQueue: "panel/addQueueMember",
      postToken: "token/postToken",
      getTrunkList: "crudService/getList",
      getUserList: 'crudService/getList',
    }),
    getFailoverActionText(queue) {
      if (!queue || !queue.failoveraction || queue.failoveraction === "null") return "";
      const action = this.actionList.find(el => el.value == queue.failoveraction);
      return action ? action.text : "";
    },
    getUserName(userId) {
      const user = this.userList.find(user => user.id == userId);
      return user?.name || '---';
    },
    setPage(pageNumber: number) {
      this.currentPageExtens = pageNumber;
    },
    nextPage() {
      if (this.currentPageExtens < this.totalPages - 1) {
        this.currentPageExtens++;
      }
    },
    prevPage() {
      if (this.currentPageExtens > 0) {
        this.currentPageExtens--;
      }
    },
    color(item: Queue | Extension | any) {
      switch (item.status) {
        case 1: // In use
          return "on-call shake";
        case 2: // Ringing
          return "ringing";
        case 3: // Connected
          return "online";
        case 4: // Hang up
          return "hangup";
        case 5: // Music on Hold
          return "on-hold";
        default: // Disconnected
          return "offline";
      }
    },

    async updateActionList() {
      const actionList = await this.getActions({
        action: action.GET_ACTIONS,
        id: this.$store.state.auth.user.corpId,
      });
      console.log("Action List", actionList);
      const arr = [];

      arr.push({ text: i18n.t("lists.---HANG UP---"), value: "---HANG UP---" });
      arr.push({ text: "Hangup", value: actionList.hangup });

      arr.push({ text: i18n.t("lists.---IVRS---"), value: "---IVRS---" });
      for (const key in actionList.ivrs) {
        arr.push({ text: key, value: actionList.ivrs[key] });
      }

      arr.push({ text: i18n.t("lists.---QUEUES---"), value: "---QUEUES---" });
      for (const key in actionList.queues) {
        arr.push({ text: key, value: actionList.queues[key] });
      }

      arr.push({ text: i18n.t("lists.---INTEGRATIONS---"), value: "---INTEGRATIONS---" });
      for (const key in actionList.integrations) {
        arr.push({ text: key, value: actionList.integrations[key] });
      }

      arr.push({ text: i18n.t("lists.---EXTENSIONS---"), value: "---EXTENSIONS---" });
      for (const key in actionList.extens) {
        arr.push({ text: key, value: actionList.extens[key] });
      }
      arr.push({ text: i18n.t("lists.---TIMES---"), value: "---TIMES---" });
      for (const key in actionList.times) {
        arr.push({ text: key, value: actionList.times[key] });
      }
      this.actionList = arr;
    }
  },


  async mounted() {
    this.trunkList = await this.getTrunkList(action.TRUNK_CONTROLLER);
    await this.updateActionList();
    this.userList = await this.getUserList(action.USER_CONTROLLER);
    this.setPage(0);

    setInterval(() => {
      this.postToken();
    }, 60000)
  },

  beforeRouteLeave(to, from, next) {
    this.postToken();
    next();
  },
});
